import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import { fetchSetDressings } from "./../../accessories/setDressings/ducks/actions";
import {
  addSetDressingToScene,
  clearRedirect
} from "./ducks/actions";
import Form from "./form";
import Loader from "../../../shared/loader";

function AddVisualEffectToScene(props) {
  const { filmId, sceneId } = props.match.params;
  const {
    fetchSetDressings,
    addSetDressingToScene,
    clearRedirect,
    errors,
    setDressings,
    sceneSetDressings,
    saving,
    setDressing
  } = props;

  const [fromBreakdown, setFromBreakdown] = useState<boolean>(false);
  useEffect(() => {
    setFromBreakdown(props.location?.state?.fromBreakdown);
  }, [props.location?.state?.fromBreakdown]);

  useEffect(() => {
    fetchSetDressings(filmId);
  }, []);

  if (props.redirect) {
    clearRedirect();
    if (props.redirect.to == "list") {
      const url = `/films/${filmId}/scenes/${sceneId}/set-dressings`;
      return <Redirect to={url} />;
    } else if (props.redirect.to == "breakdown") {
      const url = `/films/${filmId}/breakdown/scenes/${sceneId}`;
      return <Redirect to={url} />;
    }
  }

  function onAddSetDressing(setDressing) {
    sanitiseDataTypes(setDressing);
    addSetDressingToScene(filmId, sceneId, setDressing, fromBreakdown);
  }

  function sanitiseDataTypes(setDressing) {
  }

  const sceneSetDressingIds = sceneSetDressings.map(p => p.id);
  const nonSceneSetDressings = setDressings.filter((prop: any) => !sceneSetDressingIds.includes(prop.id));

  return (
    <ScrollIntoView
      className="blade-content"
      path="/films/:filmId/scenes/:sceneId/set-dressings/add"
      loading={false}>
      <Form
        mode="add"
        errors={errors}
        characterId={null}
        initialValues={setDressing}
        setDressings={nonSceneSetDressings}
        onSubmit={onAddSetDressing}
      />
      {saving && <Loader />}
    </ScrollIntoView>
  );
}

function mapStateToProps(state) {
  const { setDressingState } = state.scenesState;
  return {
    sceneSetDressings: setDressingState.setDressings,
    setDressings: state.setDressingsState.setDressings,
    setDressing: setDressingState.setDressing,
    errors: setDressingState.errors,
    redirect: setDressingState.redirect,
    saving: setDressingState.saving
  };
}

export default connect(mapStateToProps, {
  addSetDressingToScene,
  fetchSetDressings,
  clearRedirect
})(AddVisualEffectToScene);
